import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Button, Container, Input, IconButton } from '@mui/material';
import { PuffLoader } from 'react-spinners';
import html2canvas from 'html2canvas';
import { MdAirlineSeatReclineExtra } from "react-icons/md";
import { GiCarDoor } from "react-icons/gi";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { IoIosSpeedometer } from "react-icons/io";
import { GiCarWheel } from "react-icons/gi";
import { GrMapLocation } from "react-icons/gr";
import { FaLocationArrow } from "react-icons/fa";
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { IoPrint } from "react-icons/io5";
import { RiScreenshot2Fill } from "react-icons/ri";
import Select from "react-select";
import  './Report.css';
import Swal from 'sweetalert2';
import { GoogleMap, useJsApiLoader, Polygon } from '@react-google-maps/api';
import CommentIcon from '@mui/icons-material/Comment';

import domtoimage from 'dom-to-image';
import { baseURL } from '../base_url';
import axios from 'axios';

const loggedInUser = sessionStorage.getItem("tm_token");
const foundUser = JSON.parse(loggedInUser);

const mapStyles = {
    width: '100%',
    height: '87vh',
};



const AlertMaps = () => {
  
    const [geofenceCoordinates, setGeofenceCoordinates] = useState()
    const [selectedVehicle, setSelectedVehicle] = useState('');
    const [vehicleLatLongList, setVehicleLatLongList] = useState([]);
    const [vehicleDetailList, setVehicleDetailList] = useState([]);
    const [locationInfo, setLocationInfo] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState('')
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [chargeOption, setChargeOption] = useState(null)
    const [chargeStatusButtonName, setChargeStatusButtonName] = useState('Close')
    const [isChargeButtonDisabled, setIsChargeButtonDisabled] = useState(false);
    const [chargeOptionDB, setChargeOptionFromDB] = useState('');
    const [defaultCenter, setDefaultCenter] = useState({ lat: 51.081467, lng: -113.999875 });
    const [showInput, setInputField] = useState(false)
    const [amount, setAmount] = useState('0');
    const [amountDB, setAmountDB] = useState('0');
    const [showLabel, setShowLabel] = useState(false);
    const [showCommentModal, setShowCommentModal] = useState(false)
    const [currentComment, setCurrentComment] = useState('');
    const [currentAgreementNumber, setCurrentAgreementNumber] = useState('');
    const [currentAlertId, setCurrentAlertId] = useState(null);
    const [locationInfoTime, setLocationInfoTime] = useState('')


    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyC36o4niEA5vZG4bMS0CM5FBQaKEt6QADw',
      });
    const [map, setMap] = useState(null);

    const mapRef = useRef(null); // Create a ref for the map instance
    const rowRef = useRef(null); // Create a ref for the row div
    const handlePrint = () => {
      window.print();
    };

    const ConvertToTimeZone_old = (datetime, agr_number) => {
        const location = agr_number.substring(0, 3);
        const timezone = {
            'DEN': 'America/Denver',
            'AURORA':'America/Denver',
            'MCO': 'America/New_York',
            'ATL': 'America/New_York',
            'ORD': 'America/Chicago',
            'YYZ': 'America/Toronto', 
            'YYC': 'America/Edmonton',
            'YVR': 'America/Vancouver',
            'YUL': 'America/Toronto',
            'YOW': 'America/Toronto',
            "PHX": "America/Phoenix",
            "TPA":"America/New_York"
        }
        const convertedTime = moment(datetime).tz(timezone[location]).format('YYYY-MM-DD HH:mm:ss A');
        return convertedTime
        // setLocationInfoTime(convertedTime)
    };

    const ConvertToTimeZone = (datetime, loc_id) => {
        const timezone = {
            '6': 'America/Denver',
            '20':'America/Denver',
            '3': 'America/New_York',
            '5': 'America/New_York',
            '4': 'America/Chicago',
            '2': 'America/Toronto', 
            '1': 'America/Edmonton',
            '7': 'America/Vancouver',
            '9': 'America/Toronto',
            '8': 'America/Toronto',
            '12': 'America/Toronto',
            '21': 'Asia/Dubai',
            '22': 'America/Phoenix',
            '23': 'America/New_York'
        }
        // const convertedTime = moment(datetime).tz(timezone[loc_id]).format('YYYY-MM-DD HH:mm:ss A');
        const convertedTime = moment(datetime).tz(timezone[loc_id.toString()]).format('YYYY-MM-DD HH:mm:ss A');
        return convertedTime
    };

    useEffect(() => {
        setLoading(true);
        try {
            axios.get(baseURL + "/get_alert_warning_single?id=" + id).then((res) => {
            if(res.data.status === "1"){
                setSelectedVehicle({"lat":res.data.data.latitude,"lng":res.data.data.longitude,"data":res.data.data});
                setGeofenceCoordinates({"parking":res.data.data.parking,"state":res.data.data.state})
                setLocationInfo(res.data.data.location_info)
                setVehicleLatLongList([res.data.data.latitude, res.data.data.longitude])
                setVehicleDetailList({"latlong":[res.data.data.latitude, res.data.data.longitude],"agree_state":res.data.data.agreement_status,"agreement_number":res.data.data.agreement_number,"vin":res.data.data.vin})
                setCurrentAgreementNumber(res.data.data.agreement_number)
                setCurrentAlertId(res.data.data._id)
                const converted_datetime = ConvertToTimeZone(res.data.data.response_data.datetime,res.data.data.loc_id)
                setLocationInfoTime(converted_datetime)
                if(res.data.data.hasOwnProperty('charge_option'))
                {
                    setChargeOption(res.data.data.charge_option)
                    setChargeStatusButtonName(res.data.data.charge_status)
                    setIsChargeButtonDisabled(true)
                    setChargeOptionFromDB(res.data.data.charge_option)
                    setAmount(res.data.data.charge_amount)
                    setAmountDB(res.data.data.charge_amount)
                    if(res.data.data.charge_option == "charge_at_counter" || res.data.data.charge_option == "penalty_imposed")
                    {
                        setIsChargeButtonDisabled(false)
                        setInputField(true)
                        setShowLabel(true)
                    }
                }
                if(res.data.data.hasOwnProperty('comment'))
                {
                    setCurrentComment(res.data.data.comment)
                }
                setLoading(false);
            }
            })
        } catch (error) {
            // Handle errors here
            console.error(error);
        } finally {
            setLoading(false);
        }
    },[])
    
    const fetchAddress_old = async (latitude, longitude) => {
        //https://maps.googleapis.com/maps/api/geocode/json?latlng=41.6321489,-87.4780359&key=API_KEY
        try {
            const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`);
            setSelectedAddress(response.data.display_name);
        } catch (error) {
            setSelectedAddress("");
        }
    };

    const fetchAddress = async (latitude, longitude) => {
        try {
            const apiKey = "AIzaSyC36o4niEA5vZG4bMS0CM5FBQaKEt6QADw"; // Replace with your Google Maps API key

            const response = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json`,
            {
                params: {
                latlng: `${latitude},${longitude}`,
                key: apiKey,
                },
            }
            );

            if (response.data.status === "OK") {
            // setSelectedAddress(response.data.results[0].formatted_address);
            // If you specifically want the Plus Code like "3WQM+R5X Niagara Falls, New York, USA"
            // uncomment this:
            setSelectedAddress(response.data.plus_code?.compound_code || response.data.results[0].formatted_address);
            } else {
                setSelectedAddress("");
            }
        } catch (error) {
            console.error("Geocoding error:", error);
            setSelectedAddress("");
        }
    };


    const handleScreenshot = async () => {
        const agreementNumber = selectedVehicle.data.agreement_number
        const rowElement = rowRef.current;
        html2canvas(rowElement, {
            useCORS: true,
            scrollX: 0,
            scrollY: 0,
            windowWidth: document.documentElement.offsetWidth,
            windowHeight: document.documentElement.offsetHeight,
            x: rowElement.scrollLeft,
            y: rowElement.scrollTop,
            width: rowElement.offsetWidth,
            height: rowElement.offsetHeight,
        }).then(rowCanvas => {
            const combinedCanvas = document.createElement('canvas');
            const context = combinedCanvas.getContext('2d');
  
            // Set canvas dimensions to accommodate map and row div
            combinedCanvas.width = rowCanvas.width;
            combinedCanvas.height = rowCanvas.height; // Adjust as needed
  
            // Draw the row div canvas onto the combined canvas
            context.drawImage(rowCanvas, 0, 0);
  
            // Draw the map canvas onto the combined canvas below the row div
            context.drawImage(rowCanvas, 0, rowCanvas.height);
            
            // Convert combined canvas to a data URL
            const url = combinedCanvas.toDataURL();
  
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = url;
            link.download = `${agreementNumber}.png`; // Set the filename for the downloaded file
  
            // Append the link to the document body and trigger a click
            document.body.appendChild(link);
            link.click();
  
            // Clean up by removing the link from the document body
            document.body.removeChild(link);
        });
    };

    const handleInputChange = (event) => {
        let entered_amount = event.target.value;
        if(amountDB == entered_amount)
        {
            setAmount(entered_amount);
            setIsChargeButtonDisabled(true)
        }
        else{
            setAmount(entered_amount);
            setIsChargeButtonDisabled(false)
        }
    };

    const chargeStatusOption = [
        { value: 'charge_at_counter', label: 'Charged At Counter' },
        { value: 'penalty_imposed', label: 'Penalty Imposed' },
        { value: 'pending', label: 'Pending' },
        { value: 'one_way', label: 'One-Way Rental' },
        { value: 'corporate', label: 'Corporate'},
        { value: 'governemnt_reservation', label: 'Government Reservation'},
        { value: 'wrong_alert', label: 'Wrong Alert' }
    ];

    const handleChargeOption = (selectedOption) => {
        if(chargeOptionDB != selectedOption.value)
        {
            if(selectedOption.value == "charge_at_counter" || selectedOption.value == "penalty_imposed")
            {
                setChargeStatusButtonName('Close')
                setInputField(true)
                setShowLabel(true)
                setIsChargeButtonDisabled(true)
            }
            else if(selectedOption.value == "pending")
            {
                setChargeStatusButtonName('Submit')
                setInputField(false)
                setShowLabel(false)
                setAmount("0")
                setIsChargeButtonDisabled(false)
            }
            else
            {
                setChargeStatusButtonName('Close')
                setInputField(false)
                setShowLabel(false)
                setAmount("0")
                setIsChargeButtonDisabled(false)
            }
            
        }
        else
        {
            if(chargeOptionDB == "charge_at_counter" || chargeOptionDB == "penalty_imposed")
            {
                setChargeStatusButtonName('Close')
                setInputField(true)
                setShowLabel(true)
                setIsChargeButtonDisabled(true)
            }
            else if(chargeOptionDB == "pending")
            {
                setChargeStatusButtonName('Submit')
                setInputField(false)
                setShowLabel(false)
                setIsChargeButtonDisabled(false)
            }
            else
            {
                setIsChargeButtonDisabled(true)
                setInputField(false)
                setShowLabel(false)
                setChargeStatusButtonName('Closed')
            }
        }
        setChargeOption(selectedOption.value)
    }

    const handleChargeStatus = () => {
        axios.post(baseURL+"/update_charge_status",{
        iid: id,
        chargeOption:chargeOption,
        chargeAmount:amount,
        agreementNumber: selectedVehicle.data.agreement_number,
        vin: selectedVehicle.data.vin,
        admin_id: foundUser['tm_id']
        }).then((res) => 
        {
            if(res.data.success === 'success'){
                setChargeStatusButtonName(res.data.charge_status)
                setIsChargeButtonDisabled(true);
                Swal.fire('Updated', 'Charge Status Updated', 'success')
            }else{
                Swal.fire("Something went wrong.")
            }
        })
    }
  
    const onLoad = useCallback((mapInstance) => {

        setMap(mapInstance);        
        const customIcon = {
            url: require("../../assets/img/map_car_r.png"),
            scaledSize: new window.google.maps.Size(30, 25),
        };
        // Add markers
        new window.google.maps.Marker({
            position: { lat: selectedVehicle.lat, lng: selectedVehicle.lng },
            map: mapInstance,
            title: `VIN: ${selectedVehicle.data.agreement_number}`,
            icon: customIcon,
        });
        setDefaultCenter({ lat: selectedVehicle.lat, lng: selectedVehicle.lng })
        const menuList = geofenceCoordinates.state.map(latlong => ({
            lat: latlong[0],
            lng: latlong[1]
        }));
        fetchAddress(selectedVehicle.lat, selectedVehicle.lng)

        // Add polygon
        new window.google.maps.Polygon({
            paths: menuList,
            strokeColor: "#2448D9",
            strokeOpacity: 1,
            fillColor: "#2448D9",
            fillOpacity: 0.1,
            map: mapInstance,
        });
    },[selectedVehicle]);

    const handleUnitType = (value, selected_unit) => {
        if(selected_unit == "Miles"){
            return (parseFloat(value) * 0.621371).toFixed(2);
        }else if(selected_unit == "Meter"){
            return (parseFloat(value) * 1000).toFixed(2);
        }else{
            return value
        }
    };
    const handleglType = (value, selected_gl) => {
        if(selected_gl == "Gallon"){
            if(value !== undefined)
            {
                return (parseFloat(value) * 0.264172).toFixed(2);
            }
        }else{
            return value
        }
    };
    const handleInputClick = (alertId, comment_text, agreement_number ,e) => {
        setCurrentAlertId(alertId);
        setCurrentComment(comment_text);
        setCurrentAgreementNumber(agreement_number);
        setShowCommentModal(true);
      };
    const handleSaveComment = () => {
        axios.post(baseURL + "/update_comment_for_alert", {
          id: currentAlertId,
          comment: currentComment,
          admin_id: foundUser['tm_id']
        }).then((res) => {
          if (res.data === 'success') {
            Swal.fire('Updated', 'Comment Updated', 'success');
          } else {
            Swal.fire("Something went wrong.");
          }
        });
        setShowCommentModal(false);
        window.location.reload();
    };
    return (
        <div>
            {loading ? (
                <div className="loader-overlay">
                    <div className="loader">
                        <PuffLoader color="#00308F" loading={true} size={200} />
                    </div>
                </div>
            ) : ("")}
            
            <div style={{ display: "flex", justifyContent: "left", padding:"7px",marginLeft:"25px"}}>
              <Button size='small' variant="contained" onClick={handlePrint}><IoPrint size={25}/>&nbsp;Print Full Page</Button>&nbsp;&nbsp;
              <Select
                value={chargeStatusOption.find(option => option.value === chargeOption)}
                getOptionLabel={option => option.label}
                getOptionValue={option => option.value}
                name="chargeOption"
                options={chargeStatusOption}
                onChange={handleChargeOption}
                placeholder="Select Charge Status"
                className="fixed-size-select" />
                &nbsp;&nbsp;
                { showInput &&
                    <input
                    type="number"
                    value={amount}
                    onChange={handleInputChange}
                    className="number-input"
                />
                }
                &nbsp;&nbsp;
              <Button size='small' variant="contained" 
                onClick={handleChargeStatus} disabled={isChargeButtonDisabled} 
                style={isChargeButtonDisabled ? { color: 'black', fontWeight: 'bold' } : {}}>{chargeStatusButtonName}
              </Button>
              &nbsp;&nbsp;
                <IconButton size='small' onClick={(e) =>  handleInputClick(selectedVehicle.data._id,selectedVehicle.data.comment,selectedVehicle.data.agreement_number,e)} variant="contained">
                    <CommentIcon style={{ color: 'blue'}} />
                </IconButton>
              {showLabel && 
                <label style={{fontSize:"16px",color:"red"}}>***Please enter the amount without tax***</label>
                }

                {showCommentModal && currentAlertId !== null && (
                    <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                        {/* style={{backgroundColor:"#254465",color:"white"}} */}
                        <div className="modal-header"> 
                            <h5 className="modal-title" >Add/Update Comment for {currentAgreementNumber}</h5>
                            <button type="button" className="btn-close" onClick={() => setShowCommentModal(false)} aria-label="Close"></button>
                        </div> 
                        <div className="modal-body">
                            <textarea value={currentComment} onChange={(e) => setCurrentComment(e.target.value)} rows="4" cols="50" />
                        </div>
                        <div className="modal-footer">
                            {/* <Button variant="secondary" onClick={() => setShowCommentModal(false)}>Close</Button> */}
                            <Button variant="contained" onClick={handleSaveComment}>Save changes</Button>
                        </div>
                        </div>
                    </div>
                    </div>
                )}
              
            </div>
            <div style={{ display: "flex", justifyContent: "right", marginTop:"-44px", padding:"7px",marginRight:"65px"}}><Button size='small' variant="contained" onClick={handleScreenshot}><RiScreenshot2Fill size={25}/>&nbsp;Take Screenshot</Button></div>
            {selectedVehicle &&
            <div className='row' ref={rowRef}>
                <div className='col-3 car_details' style={{maxHeight:"83vh",overflowY:"auto",paddingLeft:"25px"}}>
                       <div className='row'>
                       <div className='col-12'>
                          <p className="fw-bold">{locationInfo.make} {locationInfo.model}</p>
                          <div><lable className="fw-bold">Vin : </lable>{selectedVehicle.data.vin}</div>
                          <div><lable className="fw-bold">R/A : </lable>
                           {selectedVehicle.data.agreement_number?.startsWith("DEN-")
                                ? `AURORA-${selectedVehicle.data.agreement_number.slice(4)}`
                                : selectedVehicle.data.agreement_number || ""}
                            </div>
                          <div style={{color:selectedVehicle.data.agreement_status === 'In Agreement'?'green':'grey',float:"right"}}><lable className="fw-bold">{selectedVehicle.data.agreement_status}</lable></div>
                        </div>
                      </div>
                      <hr className='hr_alert'/>
                      <div className='row'>
                        <div className='col-8'>
                          <p className="fw-bold"><GrMapLocation /> Location Info</p>
                        </div>
                        <div className='col-12'><span>Coordinates : <b>{selectedVehicle.lat}, {selectedVehicle.lng}</b></span></div>
                        <div className='col-12'><span style={{marginLeft:"15px"}}><FaLocationArrow /> {selectedAddress}</span></div>
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Date: <b style={{color:"#eb6834"}}> 
                            {(selectedVehicle.data.response_data.geolocation)?locationInfoTime:""} </b></div>
                      </div>
                      <hr  className='hr_alert'/>
                      <div className='row'>
                        <div className='col-12'>
                          <span className="fw-bold"><GiCarWheel style={{width:"25px",height:"25px"}}/>Tire Pressure</span>
                        </div>
                        {/* <div className='col-6'>Front(L): <b>{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.front.left.value:""}{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.front.left.unit:""}</b></div>
                        <div className='col-6'>Front(R): <b>{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.front.right.value:""}{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.front.right.unit:""}</b></div>
                        <div className='col-6'>Rear(L): <b>{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.rear.left.value:""}{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.rear.left.unit:""}</b></div>
                        <div className='col-6'>Rear(R): <b>{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.rear.right.value:""}{(selectedVehicle.data.response_data.tirePressure)?selectedVehicle.data.response_data.tirePressure.rear.right.unit:""}</b></div>
                        */}
                        <div className="row"> 
                          {["Front(L)", "Front(R)", "Rear(L)", "Rear(R)"].map((label, index) => {
                            const position = label.includes("Front")
                              ? "front"
                              : "rear";
                            const side = label.includes("(L)")
                              ? "left"
                              : "right";

                            const tirePressure =
                            selectedVehicle?.data?.response_data?.tirePressure?.[position]?.[side];

                            return (
                              <div className="col-6" key={index} style={{fontSize:"15px"}}>
                                {label}:{" "}
                                <b>
                                  {tirePressure?.value ? tirePressure.value.toFixed(2) + tirePressure.unit  : "N/A"}
                                  {/* {tirePressure?.unit || ""} */}
                                </b>
                              </div>
                            );
                          })}
                        </div>
                        
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Date: <b style={{color:"#eb6834"}}>
                            {/* {(selectedVehicle.data.response_data.tirePressure && selectedVehicle.data.response_data.tirePressure.front.left)?ConvertToTimeZone(selectedVehicle.data.response_data.tirePressure.front.left.datetime, selectedVehicle.data.loc_id):""}</b></div> */}
                            {
                                selectedVehicle?.data?.response_data?.tirePressure?.front?.left
                                ? ConvertToTimeZone(selectedVehicle.data.response_data.datetime,selectedVehicle.data.loc_id
                                  )
                                : "N/A"
                            }</b></div>
                        </div>
                      <hr className='hr_alert' />
                      <div className='row'>
                        <div className='col-8 d-none'>
                          <p className="fw-bold">Additional Info</p>
                        </div>
                        <div className='col-12'><IoIosSpeedometer /> Speed: <b>{(selectedVehicle.data.response_data.speed)?handleUnitType(selectedVehicle.data.response_data.speed.value,locationInfo.unit_type):"0"} {locationInfo.unit_type}/h</b></div>
                        {/* <div className='col-12'><IoIosSpeedometer /> Odometer: <b>{(selectedVehicle.data.response_data.odometer)?handleUnitType(selectedVehicle.data.response_data.odometer.value,locationInfo.unit_type):"0"} {locationInfo.unit_type}</b></div> */}
                        {/* <div className='col-12'><BsFillFuelPumpFill /> Fuel Level: <b>{(selectedVehicle.data.response_data.fuel)?handleglType(selectedVehicle.data.response_data.fuel.level.value,locationInfo.gl_type):"0"} {locationInfo.gl_type}</b></div> */}
                        <div className='col-12'><BsFillFuelPumpFill /> Fuel Level: <b>{selectedVehicle?.data?.response_data?.fuel?.level?.percentage ? selectedVehicle['data'].response_data.fuel.level.percentage + " %" : "N/A"}</b></div>
                        <div className='col-12'><BsFillFuelPumpFill /> Fuel Residual Autonomy: <b>{(selectedVehicle.data.response_data.fuel && selectedVehicle.data.response_data.fuel.residualAutonomy)?handleUnitType(selectedVehicle.data.response_data.fuel.residualAutonomy.value,locationInfo.unit_type):"0"} {locationInfo.unit_type}</b></div>
                        <div className='col-12'><MdAirlineSeatReclineExtra /> Driver Seatbelt Wearing: <b>{(selectedVehicle.data.response_data.seatbelt && selectedVehicle.data.response_data.seatbelt.driver && selectedVehicle.data.response_data.seatbelt.driver.value)?"Yes":"No"}</b></div>
                        <div className='col-12'><GiCarDoor /> Doors Locked: <b>{(selectedVehicle.data.response_data.doors && selectedVehicle.data.response_data.doors.locked && selectedVehicle.data.response_data.doors.locked.value)?"Yes":"No"}</b></div>
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Date: <b style={{color:"#eb6834"}}>{(selectedVehicle.data.response_data.engine.status)?ConvertToTimeZone(selectedVehicle.data.response_data.datetime,selectedVehicle.data.loc_id):""}</b></div>
                      </div>
                      <div className='row'>
                        <div className='col-12'>
                          <label className='mt-2' style={{float:"right"}}><i>Last Updated: <span style={{color:"red"}}>{ConvertToTimeZone(selectedVehicle.data.response_data.datetime, selectedVehicle.data.loc_id)}</span></i></label>
                        </div>
                      </div>
                      {/* <hr /> */}
                </div>
                <div className='col-9'>
                    
                { isLoaded ? (
                    <GoogleMap
                        mapContainerStyle={mapStyles}
                        zoom={12}
                        center={defaultCenter}
                        onLoad={onLoad}
                    />
                ) : (<div>Loading...</div>) }
                </div>
            </div>
            }
        </div>
    );
};

export default AlertMaps;
